module.exports = __webpack_public_path__ + "img/IND-A-3-I.e0c646ac.png";